import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProductCardList } from 'components';
import useCatalogContext from '../useCatalogContext';
import useSpecialProducts from './useSpecialProducts';

const Special = () => {
  const { t } = useTranslation();

  const { openProductModal } = useCatalogContext();

  const { isLoading, products } = useSpecialProducts();

  return (
    <>
      <div className="Catalog_header">
        <h1 className="Catalog_title">{t('catalog:special')}</h1>
      </div>
      <ProductCardList
        isLoading={isLoading}
        products={products}
        queryKey="catalog/special"
        onCardClick={openProductModal}
      />
    </>
  );
};

export default Special;
